import { useState, useEffect } from 'react';
import customHeaders, { getSpace } from '../../../common/headers';
import useGeneralStore from '../../../store/general';
import { TitlePage } from '../../../components/TitlePage/TitlePage';
import './ModalCardEvent.scss'
import { TextPage } from '../../../components/TextPage/TextPage';
import { ButtonActionDrop } from '../../../components/Buttons/ButtonActionDrop/ButtonActionDrop';
import { ButtonClose, Sceleton } from "@lk-gtcom/ecomlab-components"
import { usePushNotifications } from '../../../common/pushNotification';
import { DynamicFormComponent } from '../../../components/DynamicFormComponent/DynamicFormComponent';
import dayjs from 'dayjs';

function formatDateTime(dateString) {
    const date = new Date(dateString);

    // Форматируем дату
    const datePart = date.toLocaleDateString('ru-RU', {
        weekday: 'long',
        day: 'numeric',
        month: 'short',
    });

    // Получаем время и форматируем в AM/PM
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    const timePart = `${formattedHours}:${minutes}${ampm}`;

    return `${datePart}⋅${timePart}`;
}


const ModalCardEvent = ({
    setIsModal,
    setIsModalEdit,
    selectedEvent
}) => {

    const selectedSpace = useGeneralStore(state => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    // Обработка ошибок
    const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();

    const [loading, setIsLoading] = useState(false)
    const [dataEvent, setDataEvent] = useState(null)
    const {
        attributes,
        start_time,
        end_time,
        author_id,
        created_at,
        custom_attributes,
        deleted_at,
        description,
        event_type_id,
        id,
        space_id,
        title,
        updated_at } = dataEvent || {}

    // Кастомные поля
    const [fields, setFilds] = useState([]);

    // Получить событиt
    const fetchGetEvent = (abortController = new AbortController()) => {
        setIsLoading(true)
        let url = `https://apps0.ecomru.ru:4553/api/v1/event/${selectedEvent}`;

        fetch(url, { method: 'GET', headers, signal: abortController.signal, })
            .then(res => res.json())
            .then(json => {
                setDataEvent(json)
            })
            .catch(err => console.error(err))
            .finally(() => {
                setIsLoading(false)
                if (abortController.signal.aborted) return;
            });
    };

    // Удалить событие
    const fetchDeleteEvent = (abortController = new AbortController()) => {
        let url = `https://apps0.ecomru.ru:4553/api/v1/event/${selectedEvent}`;

        fetch(url, { method: 'DELETE', headers, signal: abortController.signal, })
            .then(res => res.json())
            .then(json => {
                addSuccessPush('Событие успешно удалено')
                setTimeout(() => setIsModal(false), 500)
            })
            .catch(err => console.error(err))
            .finally(() => {
                if (abortController.signal.aborted) return;
            });
    };

    // Получение полей
    const fetchGetCustomFields = (abortController = new AbortController()) => {
        let url = `https://apps0.ecomru.ru:4553/api/v1/event/${selectedEvent}/space-custom-attribute`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                const list = json.map(({ name, custom_attribute_id, type, value, possible_values, field_source }) => {

                    return {
                        front_name: name,
                        data_type: type,
                        id: custom_attribute_id,
                        value: (type == 'bool' || value === 'null') ? JSON.parse(value) : value,
                        possible_values: possible_values,
                        field_source: field_source
                    };
                });

                setFilds(list)
            })
            .catch((err) => console.error(err));
    };

    // Запись полей
    const fetchSetValueField = (id, value) => {
        let url = `https://apps0.ecomru.ru:4553/api/v1/event/${selectedEvent}/space-custom-attribute`

        const body = JSON.stringify({
            custom_attribute_id: id,
            value: (typeof value == 'string' || Array.isArray(value)) ? value : JSON.stringify(value)
        })

        fetch(url, { method: 'POST', headers, body })
            .then((res) => res.json())
            .then((json) => {
                // if (Array.isArray(json)) {
                //     setFilds(json)
                // }
            })
            .catch((err) => console.error(err));
    };

    const btns = [
        {
            btn: 'Редактировать', func: (e) => {
                setIsModalEdit(true)
                setIsModal(false)
            }
        },
        {
            btn: 'Удалить', func: (e) => {
                fetchDeleteEvent()
            }
        }
    ];


    useEffect(() => {
        fetchGetEvent()
    }, [selectedEvent]);

    useEffect(() => {
        fetchGetCustomFields()
    }, [selectedEvent]);

    console.log(fields)

    return (
        <>
            {
                loading
                    ?
                    <div className='modal-card-event'>
                        <Sceleton
                        />
                    </div>
                    :
                    <div className='modal-card-event'>
                        <div className='modal-card-event__content-header'>
                            <header className='modal-card-event__header'>
                                <TitlePage
                                    title={event_type_id === 1 ? `Мероприятие ID-${id}` : `задача ID-${id}`}
                                />

                                <div className='modal-card-event__settings'>
                                    <ButtonActionDrop
                                        size='s'
                                        btns={btns}
                                        id={id}
                                    />

                                    <ButtonClose
                                        s
                                        onClick={() => {
                                            setIsModal(false)
                                        }}
                                    />
                                </div>
                            </header>

                            <TextPage
                                style={{
                                    fontSize: '12px',
                                    marginLeft: 'auto'
                                }}
                                text={<>Дата создания: <span style={{ color: ' #64748B' }}>{dayjs(created_at).format('DD.MM.YY HH:mm')}</span></>}
                            />
                        </div>

                        <div className='modal-card-event__content'>
                            <TitlePage
                                style={{
                                    color: '#3900B1',
                                    fontWeight: 600
                                }}
                                medium
                                title={`■ ${title}`}
                            />

                            <TextPage
                                style={{
                                    fontSize: '12px'
                                }}
                                text={formatDateTime(start_time) + ' - ' + formatDateTime(end_time)}
                            />

                            <TextPage
                                style={{
                                    color: description ? '' : '#9daabb'
                                }}
                                text={description || 'Комментарии отсутствуют'}
                            />
                        </div>
                        <div className='modal-card-event__content'>
                            <TitlePage
                                medium
                                title={`Дополнительная информация`}
                            />

                            <DynamicFormComponent
                                readonly
                                productTemporary={fields}
                                fetchSetValue={fetchSetValueField}
                            />
                        </div>
                    </div>}
        </>
    )
}

export { ModalCardEvent }